/**
 * @generated SignedSource<<2b5b8252866771d98c910ee62b1a15ce>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type aiCreditsPolicyDialogAcceptMutation$variables = Record<PropertyKey, never>;
export type aiCreditsPolicyDialogAcceptMutation$data = {
  readonly acceptAICreditsPolicy: {
    readonly aiCreditsPolicyAccepted: boolean;
    readonly id: string;
  } | null;
};
export type aiCreditsPolicyDialogAcceptMutation = {
  response: aiCreditsPolicyDialogAcceptMutation$data;
  variables: aiCreditsPolicyDialogAcceptMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Seller",
    "kind": "LinkedField",
    "name": "acceptAICreditsPolicy",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "aiCreditsPolicyAccepted",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "aiCreditsPolicyDialogAcceptMutation",
    "selections": (v0/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "aiCreditsPolicyDialogAcceptMutation",
    "selections": (v0/*:: as any*/)
  },
  "params": {
    "cacheID": "95522e27745fe0e9e184edd8290d4286",
    "id": null,
    "metadata": {},
    "name": "aiCreditsPolicyDialogAcceptMutation",
    "operationKind": "mutation",
    "text": "mutation aiCreditsPolicyDialogAcceptMutation {\n  acceptAICreditsPolicy {\n    id\n    aiCreditsPolicyAccepted\n  }\n}\n"
  }
};
})();

(node as any).hash = "a42855bc0d872469ba574c2a9f7b4967";

export default node;
